import axios from 'axios';

export default {
  get: params => axios.get('/api/v1/gmva/plant-input', { params }),
  getGraphData: params => axios.get('/api/v1/gmva/plant-input/graphic', { params }),
  getPdf: params => axios.get('/api/v1/gmva/plant-input/pdf', { params }),
};
